import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { SLOT_FIELDS } from '@ubeya/shared/constants';
import NotesRenderer from 'timeSheet/components/CellRenderers/NotesRenderer';

const useReviewOnEmployeeColumn = ({ updateReviewOnEmployee }) => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return NotesRenderer({
        rowData: params.data,
        columnData: {
          onUpdate: updateReviewOnEmployee,
          key: SLOT_FIELDS.reviewOnEmployee,
          enablePreviewModal: true,
          isSingleRow: true
        }
      });
    },
    [updateReviewOnEmployee]
  );

  return useMemo(
    () => ({
      field: 'reviewOnEmployee',
      headerName: t('reviewOnEmployee'),
      width: 160,
      initialHide: true,
      sortable: false,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useReviewOnEmployeeColumn;
